<div class="panel-header">
  <span class="panel-title">HYPOTHESIS TEST</span>
</div>

<!-- ── Decision ────────────────────────────────────────────────────────── -->

<div class="decision-section" [class.reject-accent]="rejectNull()" [class.accept-accent]="!rejectNull()">
  <div class="decision-verdict">
    <dojo-markdown-viewer [content]="decisionLabel()" />
  </div>
  <span class="decision-subtitle">{{ decisionSubtitle() }} · {{ evidenceStrength() }} evidence</span>
</div>

<!-- ── Test Statistics ─────────────────────────────────────────────────── -->

<div class="measure-section">
  <div class="section-header">
    <span class="section-label">Test Statistics</span>
    <button class="crit-table-btn" (click)="openCriticalTable()">
      <dojo-icon icon="table" [size]="10" />
      <span>Critical Table</span>
    </button>
  </div>

  <mat-accordion multi displayMode="flat" class="measures-accordion">
    @for (m of testMeasures(); track m.def.id) {
      <mat-expansion-panel
        class="measure-panel"
        [expanded]="isExpanded(m.def.id)"
        (opened)="onPanelOpened(m.def.id)"
        (closed)="onPanelClosed(m.def.id)"
      >
        <mat-expansion-panel-header [collapsedHeight]="'36px'" [expandedHeight]="'36px'">
          <mat-panel-title class="measure-header-content">
            <dojo-markdown-viewer class="measure-symbol" [content]="m.def.symbolLatex" />
            <span class="measure-label-group">
              <span class="measure-label">{{ m.def.label }}</span>
              <dojo-icon
                class="measure-info"
                icon="circle-info"
                [size]="11"
                [matTooltip]="m.def.description"
                matTooltipPosition="right"
              />
            </span>
            <span class="measure-value" [style.color]="measureColors[m.def.id]">{{ m.formattedValue }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          @if (m.formula) {
            <div class="formula-section">
              <div class="formula-line">
                <dojo-markdown-viewer [content]="m.formula" />
              </div>
            </div>
          }
        </ng-template>
      </mat-expansion-panel>
    }
  </mat-accordion>
</div>

<!-- ── Sample Statistics ───────────────────────────────────────────────── -->

<div class="measure-section">
  <div class="section-header">
    <span class="section-label">Sample Statistics</span>
  </div>

  <mat-accordion multi displayMode="flat" class="measures-accordion">
    @for (s of sampleStats(); track s.def.key) {
      <mat-expansion-panel
        class="measure-panel"
        [expanded]="isExpanded('stat-' + s.def.key)"
        (opened)="onPanelOpened('stat-' + s.def.key)"
        (closed)="onPanelClosed('stat-' + s.def.key)"
      >
        <mat-expansion-panel-header [collapsedHeight]="'36px'" [expandedHeight]="'36px'">
          <mat-panel-title class="measure-header-content">
            <dojo-markdown-viewer class="measure-symbol" [content]="s.def.symbolLatex" />
            <span class="measure-label-group">
              <span class="measure-label">{{ s.def.label }}</span>
              @if (s.def.description) {
                <dojo-icon
                  class="measure-info"
                  icon="circle-info"
                  [size]="11"
                  [matTooltip]="s.def.description"
                  matTooltipPosition="right"
                />
              }
            </span>
            <span class="measure-value" [style.color]="sampleStatColor">{{ s.formattedValue }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <div class="formula-section">
            <div class="formula-line">
              <dojo-markdown-viewer [content]="s.formula" />
            </div>
          </div>
        </ng-template>
      </mat-expansion-panel>
    }
  </mat-accordion>
</div>

<!-- ── Interpretation ──────────────────────────────────────────────────── -->

<div class="measure-section">
  <div class="section-header">
    <span class="section-label">Interpretation</span>
  </div>
  @for (line of interpretationLines(); track $index) {
    <div class="interpretation-line">
      <dojo-markdown-viewer [content]="line" />
    </div>
  }
</div>
